@if (showFooter) {
  <footer
    fxFlex="0 1 1400px"
    fxLayout="column"
    fxLayout.gt-sm="row"
    >
    <div fxFlex.gt-sm="0 0 32%">
      <span class="label">Adres</span>
      Verlengde Hoogravenseweg 13<br>
      3525 BB Utrecht
    </div>
    <div fxFlex.gt-sm="0 0 16%">
      <span class="label">E-mail</span>
      info&#64;orcaroeien.nl
    </div>
    <div fxFlex.gt-sm="0 0 16%">
      <span class="label">Telefoon</span>
      (+31) 030 2890 860
    </div>
    <div fxFlex.gt-sm="1 0" class="coat_of_arms">
      <img src="/assets/images/wapen.svg" alt="Wapen van Orca">
    </div>
  </footer>
}
